import {  Component, OnInit ,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { AfairsSettingService } from 'src/app/shared/services/hr/afairs-setting.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-tax-setting',
  templateUrl: './tax-setting.component.html',
  styleUrls: ['./tax-setting.component.scss']
})
export class TaxSettingComponent extends SuperComponent implements OnInit {
  customDataSource: any;
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  constructor( translate: TranslateService,public router:Router,Objects: ObjectsService,public AfairsSettingService:AfairsSettingService,
      gt: genericCustomStoreService,public route:ActivatedRoute,public NotifyService:NotifyService) {
      super(Objects, translate, gt)
     this.gt.getdropdowndata('TaxScheduleSetting').subscribe(res=>{
      this.customDataSource =res;
     })  
    setTimeout(() => {
      this.grid.instance.refresh()
    }, 500)
  }
  ngOnInit(): void { }
  onEditingStart(e:any) {    
    e.cancel=true
    this.router.navigate(['../add-edit-TaxSchedule-Setting'],{relativeTo:this.route})
    this.AfairsSettingService.$TAX_ID.next(e.key?.id ?? 0)
  }
  onRowRemoving(e: any) {
    this.AfairsSettingService.deleteRow('TaxScheduleSetting', e.data.id).subscribe(res=>{
      this.NotifyService.notifyfun('delete')
    },(err=>{
      this.gt.getdropdowndata('TaxScheduleSetting').subscribe(res=>{
        this.customDataSource =res;
       })  
    }))

  }
}